<template>
  <div class="content-page">
<!--      <v-card
      width="100%"
      min-height="100vh"
      tile
      flat
      class="black--text text-center"

    >   -->  
    <v-row justify="center" class="ma-0 pa-0">
      <v-col  cols="12" sm="10" md="10" lg="12" xl="12" class="pa-0">

        <v-row justify="start" class="ma-0 pa-0">
            <v-col cols="2">

          </v-col>
          <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="text-left">
              <p v-html="descriptionPage"></p>

          </v-col>
        </v-row>
      </v-col>



    </v-row>
      <SeoBlock 
        :seotxt1="dataPage !== null ? dataPage.seo_text_1: ''"
        :seotxt2="dataPage !== null ?dataPage.seo_text_2: ''"
        :seogallery="dataPage !== null ? dataPage.seo_images: []"
      />    
<!--      </v-card> -->

  </div>
</template>

<script>


import SeoBlock from "@/components/SeoBlock";
import Phone from '@/components/Phone'
import Email from '@/components/Email'
import axios from "axios"
export default {
  name: 'SinglePage',
  components: {    
    Phone,
    Email,
    SeoBlock
  },
  props: 
    {
    pageDescription:{
      type:String,
      default: ''
      },

  },  
  data: () => ({
    descriptionPage:'',
    dataPages:null,
    dataPage:null,
  }),
        metaInfo: {
          title: 'Страница',

        },
methods:{
async  loadDataP(){
let vApp = this;
          axios({
        method: "get",
        url:
          "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_site_pages",
      })
        .catch(function (error) {
        if(DEBUG) console.log("ERROR: ", error);
        })
        .then(function (response) {
         if(DEBUG) console.log("loadDataP response dataPAGES =", response.data.pages);
        vApp.allPages = response.data.pages;
        const getUrlPage = vApp.$route.params.namePage;
         vApp.dataPage =  vApp.allPages.find((fp)=>fp.slug === getUrlPage);
         
        vApp.titleInnert = vApp.dataPage.title;
        vApp.descriptionPage = vApp.dataPage.description
        // state.loadAllData.getSitePages = true;
        });
  }
},
  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    

/*     descriptionPageContacts: {
      get () {
        return this.$store.state.pages.allPages.find(fd=>fd.slug==='contacts');
      },

    },  */   
    allPages: {
      get () {
        return this.$store.state.pages.allPages
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('setAllPages', val)
      }
    },    
    isMobile: {
      get () {
        return this.$store.state.app.isMobile
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('setIsMobile', val)
      }
    },    
        titleInnert: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.titleInner);
            return this.$store.state.app.titleInner;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setTitleInner', val)
          }
        }
  },
async  created(){
    let vApp = this
    vApp.loadDataP();

  },
  mounted  () {    
    if(DEBUG) console.log('mounted Pages')
    let vApp = this
    vApp.titleInnert = ''
    vApp.descriptionPage = ''
    this.$nextTick( function () {
      

      let scrollEl = document.querySelector('#scrollT')
      scrollEl.scrollTo(0,0)
        

/*        const getInfoPage = vApp.dataPages.find(fdp=>fdp.slug === vApp.$route.params.namePage)
      vApp.titleInnert = getInfoPage.title;
      vApp.descriptionPage = getInfoPage.description  */

    })
  }

};
</script>

<style scoped>
.content-page{
  min-height: 100vh;
}
</style>